<template>
  <g-popup title="" width="800" :background-click="false" :instKey="instKey">
    <template #header>
      <div class="-wrapper-h-v-center" >
            <h3 class="-h1 -font-weight-medium -pl-5" v-text="$t('pages_user_UserCreateAccount.4')"></h3>
        </div>
    </template>
    <template #body>
        <g-search-bar
            full
            id="group-create-title"
            maxlength="255"
            class="-width-100 -border-left -border-right -mt-4"
            style="border-top:1px solid"
            placeholder="Search anything"
            v-model="thisSearchName"
          />
        <ag-grid-vue id="company-popup-ag-grid-vue"
                     style="height: 300px;"
                     class="ag-theme-balham"
                     row-height="30"
                     header-height="30"
                     :defaultColDef="defaultColDef"
                     :columnDefs="columnDefs"
                     :gridOptions="gridOptions"
                     :rowData="customerList"
                     rowSelection="single"
                     :overlayLoadingTemplate="overlayLoadingTemplate"
                     :loadingOverlayComponent="loadingOverlayComponent"
                     :loadingOverlayComponentParams="loadingOverlayComponentParams"
                     :overlayNoRowsTemplate="overlayNoRowsTemplate"
                     :noRowsOverlayComponent="noRowsOverlayComponent"
                     :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
                     :frameworkComponents="frameworkComponents"
                     :modules="modules"
                     :paginationPageSize="paging.size"
                     :pagination="true"
                     :suppressPaginationPanel="true"
                     :suppressScrollOnNewData="true"
                     @pagination-changed="paginationChanged"
                     @grid-ready="onGridReady"
                     @row-data-changed="onRowDataChanged"
                     @selection-changed="onSelectionChanged"
                     >
        </ag-grid-vue>

        <g-pagenation
          id="product-productlist-g-pagenation"
          class="-py-6"
          :page-no="paging.pageNo"
          :page-size-list="pageSizeList"
          :page-size="paging.size"
          :total-count="paging.totalCount"
          @change-page-no="onChangePageNo"
          @change-page-size="onChangePageSize"/>
      
    </template>
    <template #footer>
      <g-button
          id="customer-info-save"
          variant="borderless"
            class="-btn"
            :text="$t('common.ok')"
            @click="onClickCancel">
          <span>{{$t('common.cancel')}}</span>
        </g-button>

        <g-button @click="onSelect" :disabled="!isSelected"><span>{{$t('common.select')}}</span></g-button>
    </template>
  </g-popup>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from '@/pages/mixin/AgGrid.mixin'
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants";

export default {
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  props: {
    instKey: {
      type: String,
      default: null
    },
    onSend: {
      type: Function,
      defalut: () => () => {}
    },
    onCancel: {
      type: Function,
      defalut: () => () => {}
    },
    selectedManagerId: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      searchText: '',
      selectedValue: {},
      columnDefs: {},
      defaultColDef: {},
      gridOptions: null,
      customerList: null,
      size: 5,
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      paging: {
        pageNo: 1,
        size : DEFAULT_PAGE_SIZE,
        totalCount : 0
      },
      thisSearchName: '',
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    isSelected () {
      return Object.keys(this.selectedValue).length !== 0
    },
  },
  methods: {
    ...mapActions('customer', ['getCustomersAllList']),
   
    async onGridReady(params) {
      this.setGridParams(params)
      var list = await this.getCustomersAllList();
      this.customerList = list.filter(cus => cus.customerCode != 'X1000' )
      this.setGridParams(params)
      this.fitGrid()
    },
    onSelect () {
      this.onSend(this.selectedValue);
      this.$popupManager.close(this.instKey)
    },
    onClickCancel () {
      this.$popupManager.close(this.instKey)
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    onChangePageNo (pageNo) {
      this.paging.pageNo = pageNo;
      this.gridApi.paginationGoToPage(pageNo - 1);
    },
    onChangePageSize (pageSize) {
      this.paging.size = pageSize;
      this.paging.pageNo = 1;
      this.gridApi.paginationSetPageSize(this.paging.size);
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
      this.fitGrid();
    },
    paginationChanged (e) { // totalcount 업데이트
      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
    },
    setColumn () {
      this.columnDefs = [
        {
          headerName: this.$t('common.company_name'),
          field: "customerName",
          width: 40,
          cellStyle : {"cursor":"pointer"},
        },
        {
          headerName: this.$t('common.company_dept_name'),
          field: "deptName",
          width: 40,
          cellStyle : {"cursor":"pointer"},
        },
        {
          headerName: this.$t('common.company_no'),
          field: "customerRegistorNo",
          width: 20,
          cellStyle : {"cursor":"pointer"},
        },
      ];
      this.fitGrid()
    },
    onSelectionChanged () {
      this.selectedValue = this.gridApi.getSelectedRows()[0];
    }
  },
  
  watch: {
    thisSearchName () {
      this.gridOptions.api.setQuickFilter(this.thisSearchName)
      this.paging.pageNo = 1
    },
  }
  
}
</script>
<style>
.ag-theme-balham .ag-root{
  border: 0px;
  border-left: 1px solid #d3d8e0 !important;
  border-right: 1px solid #d3d8e0 !important;
  
}
</style>


// WEBPACK FOOTER //
// src/pages/user/components/CustomerListPopup.vue